module.exports = __webpack_public_path__ + "static/media/stars-2732.be48245b.webp";